export default "__VITE_ASSET__03c7a9fb__"